import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { ROUTES } from '../../lib/constants'
import { CommunityHero } from '../../components/CommunityHero/CommunityHero'
import { Banner } from '../../components/Banner/Banner'
import { CLEARCO_WIDGET_CODE } from '../../lib/constants';
import styles from './JoinOurTeam.module.scss'

export const JoinOurTeam = (): React.JSX.Element => {
  useEffect(() => {
      const script = document.createElement('script');
      script.src = `https://careers-content.clearcompany.com/js/v1/career-site.js?siteId=${CLEARCO_WIDGET_CODE}`;
      script.async = true;

      // Replace 'myDivId' with the actual ID of your target div
      const clearcoEmbedDiv = document.getElementById("clearcoEmbed");
      clearcoEmbedDiv!.appendChild(script);
  }, []);

  return (
    <>
      <Helmet>
        <title>{ROUTES.joinOurTeam.title}</title>
      </Helmet>

      <CommunityHero type="Join" />

      <section className={styles.openPositions}>
        <div className='grid-12'>
          <div className={styles.container}>
            <h2 className='headline__h1 color--marina-blue'>
              Open Positions
            </h2>

            <div className={styles.container}>
              <div id="clearcoEmbed"></div>
            </div>
          </div>
        </div>
      </section>

      <Banner
        headline="Have questions? Contact us today at:"
        btnText="hrgroup@citysidefiber.com"
        btnLink={'mailto:hrgroup@citysidefiber.com'}
      />
    </>
  )
}
